import { render, staticRenderFns } from "./VegetationBionet.vue?vue&type=template&id=ddf26f54&"
import script from "./VegetationBionet.vue?vue&type=script&lang=js&"
export * from "./VegetationBionet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports